export const isAdminUser = (user) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (!user.email) return false;
  const adminDomain = process.env.REACT_APP_ADMIN_DOMAIN || 'orbisappsec.com';
  return user.email.split('@')[1] === adminDomain;
};
